import { render, staticRenderFns } from "./terms-zh-TW.vue?vue&type=template&id=1c195f99"
import script from "./terms-zh-TW.vue?vue&type=script&lang=ts"
export * from "./terms-zh-TW.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports